import { getZendeskKnowledge } from "actions/zendesk";
import Button from "components/Buttons/Button";
import GlobalErrorLayout from "components/Error/GlobalErrorLayout";
import LoadingSpinner from "components/Loaders/LoadingSpinner";
import { browserRoutes } from "constants/routes";
import useSelector from "hooks/useSelector";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { NavLink, useHistory, useParams, useRouteMatch } from "react-router-dom";
import { LoadingState } from "types/api";
import { LoadingSpinnerSize } from "types/loadingSpinner";
import "./SectionList.scss";

const SectionList = () => {
    const { url } = useRouteMatch();
    const history = useHistory();
    const intl = useIntl();
    const dispatch = useDispatch();
    const { categorySlug } = useParams<{
        categorySlug: string;
    }>();

    const zendeskKnowledge = useSelector((state) => state.zendeskKnowledge);
    useEffect(() => {
        zendeskKnowledge.status !== LoadingState.loading && dispatch(getZendeskKnowledge());
    }, []);
    if (zendeskKnowledge.status === LoadingState.failure) {
        return <GlobalErrorLayout />;
    }
    if (!zendeskKnowledge.data && zendeskKnowledge.status === LoadingState.loading) {
        return <LoadingSpinner size={LoadingSpinnerSize.large} absoluteCenter />;
    }
    if (!zendeskKnowledge.data) {
        return null;
    }

    const goBack = () => {
        history.push(`/${browserRoutes.collection}`);
    };

    const selectedCategory = zendeskKnowledge.data.categories.find(
        (category) => category.slug === categorySlug,
    );

    return (
        <div>
            <div className="sections">
                <Button size="small" variant="secondary" onClick={goBack}>
                    {intl.formatMessage({ id: "collection_page.section.go_back" })}
                </Button>
                <div className="category-title">{selectedCategory?.title}</div>
            </div>
            <div className="sections-container">
                {selectedCategory?.sections?.map((section, i) => {
                    return (
                        section?.articles?.length !== 0 && (
                            <NavLink
                                key={`${section.id}-${i}`}
                                to={`${url}/${section.slug}`}
                                className="section"
                                activeClassName="section--selected"
                            >
                                {section.title}
                            </NavLink>
                        )
                    );
                })}
            </div>
        </div>
    );
};

export default SectionList;
